import { CoachCardContainer } from "./style.js";
import { CircularProgress } from "@mui/material";
import coachTestImg from "../../assets/coach-fallback.png";

const CoachCard = ({ data, startSimulation, startingCoachId }) => {
  const isAnyStarting =
    startingCoachId !== null && startingCoachId !== undefined;
  const isThisStarting = startingCoachId === data.id;

  return (
    <CoachCardContainer className="coach-card">
      <div
        className="coach-image"
        style={{ backgroundImage: `url(${data.image ? data.image : coachTestImg})` }}
      ></div>
      <div className="coach-card-content">
        {data.logo && <img src={data.logo} alt="" className="logo" />}
        <div className="title">
          <h2>{data.name}</h2>
          {data.program && (
            <span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_23_41)">
                  <path
                    d="M2 7.00002L2.78732 10.1493C2.80947 10.2379 2.82054 10.2822 2.83363 10.3208C2.96158 10.6986 3.30176 10.9642 3.69926 10.9967C3.73995 11 3.7856 11 3.8769 11C3.99122 11 4.04838 11 4.09654 10.9953C4.5725 10.9492 4.94917 10.5725 4.99533 10.0966C5 10.0484 5 9.99124 5 9.87691V2.75002M9.25 6.75002C10.2165 6.75002 11 5.96652 11 5.00002C11 4.03352 10.2165 3.25002 9.25 3.25002M5.125 2.75002H3.25C2.00736 2.75002 0.999999 3.75738 1 5.00002C1 6.24266 2.00736 7.25002 3.25 7.25002H5.125C6.00821 7.25002 7.08862 7.72346 7.92215 8.17784C8.40841 8.44292 8.65155 8.57546 8.81079 8.55595C8.95845 8.53787 9.0701 8.47157 9.15666 8.35057C9.25 8.22009 9.25 7.95902 9.25 7.43687V2.56316C9.25 2.04101 9.25 1.77994 9.15666 1.64946C9.0701 1.52847 8.95845 1.46217 8.81079 1.44408C8.65155 1.42458 8.40841 1.55712 7.92215 1.82219C7.08862 2.27657 6.00821 2.75002 5.125 2.75002Z"
                    stroke="#FEFEFE"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_23_41">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              {data.program}
            </span>
          )}
        </div>
        <p>{data.short_description}</p>
        {data.tags && data.tags.length > 0 && (
          <ul>
            {data.tags.map((tag, i) => (
              <li key={`tag-${i}`}>{tag}</li>
            ))}
          </ul>
        )}
      </div>
      <div className="coach-card-footer">
        <button
          onClick={() => startSimulation(data.id)}
          disabled={isAnyStarting}
        >
          {isThisStarting ? (
            <>
              Simulation Loading
              <CircularProgress size={20} style={{ color: "#fff" }} />
            </>
          ) : (
            <>
              Start Conversation
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.16666 10H15.8333M15.8333 10L9.99999 4.16669M15.8333 10L9.99999 15.8334"
                  stroke="#FEFEFE"
                  strokeWidth="1.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </>
          )}
        </button>
      </div>
    </CoachCardContainer>
  );
};

export default CoachCard;
